import Vue from 'vue';
import Router from 'vue-router';
// import Home from './views/Home.vue';

Vue.use(Router);

const APP_NAME = process.env.VUE_APP_NAME;

// lazy load function
function loadView(view) {
	return () => import(/* webpackChunkName: "view-[request]" */ `@/views/${view}.vue`);
}
// lazy load function
function loadComponent(view) {
	return () => import(/* webpackChunkName: "component-[request]" */ `@/components/${view}.vue`);
}

export default new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	// linkActiveClass: 'active',
	scrollBehavior() {
		return { x: 0, y: 0 };
	},
	routes: [
		// Dashboard
		{
			path: '/',
			name: 'display-access',
			component: loadView('DisplayAccess'),
			meta: {
				title: `Display Access - ${APP_NAME}`,
				gtm: 'Display Access',
			},
		},
		{
			path: '/multiview-displays/:id',
			name: 'MultiviewOutputDisplay',
			component: loadView('MultiviewOutputDisplay'),
			meta: {
				title: `Multiview Output - ${APP_NAME}`,
				gtm: 'Multiview Output',
			},
		},
		// Displays live for live
		{
			path: '/displays/live/:displaySlug/:id',
			name: 'DisplayLive',
			component: loadView('DisplayLive'),
			meta: {
				title: `Display live - ${APP_NAME}`,
				gtm: 'Displays',
			},
		},
		// 404
		{
			path: '/error-404',
			name: 'Error404',
			component: loadComponent('Error404'),
			meta: {
				title: '404',
				gtm: 'Error 404',
				hideSidebar: true,
			},
		},
		// Redirect to 404 page, if no match found
		{
			path: '*',
			redirect: '/error-404',
		},
	],
});
